export default __webpack_public_path__ + "static/SONY_IMX335_Indoor-e6f4cc305a36f777fb7ffb6b944777fa.webp";